export function clearPortalSession() {
  for (const key of ['token', 'tokenExpiration', 'selectedClientId', 'clientName', 'clientLastName']) localStorage.removeItem(key);
}

export async function signOutPortal(portal) {
  const token = localStorage.getItem('token');
  // Finish this browser's logout immediately, including when the API is offline.
  clearPortalSession();
  if (!token) return { signedOut: true, remoteConfirmed: false };
  let timer, controller;
  try {
    if (typeof AbortController !== 'undefined') controller = new AbortController();
    const response = await Promise.race([
      fetch(`${process.env.VUE_APP_BACKEND_DOMAIN}/api/${portal}-devices/logout`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
        credentials: 'include', ...(controller ? { signal: controller.signal } : {}),
      }),
      new Promise(resolve => { timer = setTimeout(() => { controller?.abort(); resolve(null); }, 2000); }),
    ]);
    return { signedOut: !localStorage.getItem('token'), remoteConfirmed: Boolean(response?.ok) };
  } catch {
    return { signedOut: !localStorage.getItem('token'), remoteConfirmed: false };
  } finally { clearTimeout(timer); }
}
